import { i18n } from 'next-i18next/pages';

/** Функция для получения перевода там, где нет возможности использовать ``useTranslation``
 *
 * @param namespace - раздел перевода
 *
 * @returns функцию, принимающую ключ и возврашающую перевод
 */
export const getTranslated = (namespace: string) => (key: string, params?: object) =>
	i18n?.t(key, { ns: namespace, ...params }) ?? key;
